import React from 'react';
import { ReactComponent as HiddenEyeWatermark } from '../../assets/images/icons/hiddenEyeWatermark.svg';

export default function HiddenEyeWatermarkIcon(props) {
  return (
    <HiddenEyeWatermark className={`icon ${props.className}`} />
  );
}
